<div class="fix-left-section-container">
  <!-- Share Section -->
  <div class="share-section mb-4">
    <div class="share-text mb-2">شارك المقال على</div>
    <div class="social-icons d-flex justify-content-end gap-2">
      <a href="#" class="social-icon">
        <i class="fa-brands fa-twitter"></i>
      </a>
      <a href="#" class="social-icon">
        <i class="fa-brands fa-facebook-f"></i>
      </a>
    </div>
  </div>

  <div class="watch-also-wrapper position-relative">
    <div class="green-backdrop"></div>
    <div class="gray-content-card">
      <h4 class="section-title mb-4">شاهد ايضا</h4>
      <ul class="custom-list p-0 m-0">
        <li>
          <a class="dropdown-item" [routerLink]="'/InvestorsCenterComponent'">مركز خدمات المستثمرين</a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" [routerLink]="'/InvestorsAgentsComponent'">مركز شئون وكلاء المستثمرين بالهيئة</a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" [routerLink]="'/InvestorsDisputeComponent'">مركز تسوية منازعات المستثمرين</a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" [routerLink]="'/FrequentlyAskedQuestionsComponent'">الاسئلة الشائعة</a>
        </li>
        <li>
          <a class="dropdown-item" [routerLink]="'/SocialResponsibilityComponent'">المسئولية المجتمعية للشركات</a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" [routerLink]="'/CareEgyptianInvestorsComponent'">وحدة رعاية المستثمرين المصريين
            المقيمين بالخارج</a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" [routerLink]="'/EconomicperformanceHelpComponent'">الأداء الاقتصادي</a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" [routerLink]="'/EgyptianCitizenshipComponent'">وحدة منح الجنسية المصرية مقابل
            الاستثمار</a>
        </li>
                <li>
          <a class="dropdown-item" [routerLink]="'/DataStaticComponent'">بيانات إحصائية</a>
        </li>
      </ul>
    </div>
  </div>
</div>